export default class Image {
  constructor(api) {
    this.api = api;
  }

  getByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/images/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/image.js